import _ from 'lodash';
import RouteHelper from './route-helper';

var AA_PAGE = 'historical2-app-view';
const AA_APP = 'historical2';
var USER_DETAILS_CONTAINER = 'historical2-user-details-container-view';
var VIEW = {
    DASHBOARD: 'historical2-dashboard-view',
    ADOPTION: 'historical2-adoption-view',
    ISSUES: 'historical2-issues-view',
    CAPACITY: 'historical2-capacity-view',
    ROOMS_BOARDS: 'historical2-roomboard-view',
    DATASET: 'historical2-dataset-view',
    SCHEDULES: 'historical2-schedules-view',
    CAPACITY_DETAILS: 'capacity-details-view',
    SETTINGS: 'settings-view',
    USER_DETAILS: 'historical2-user-details-view'
};
var Dataset = {
    Endpoints: {
        id: 'historical2endpoints',
        uri: 'endpoints',
        pageName: 'Endpoints',
        shareNameDictionary: [
            'Historical Managed Endpoints',
            'Historical Unmanaged Endpoints',
            'Historical Endpoint Inventory',
            'Historical Endpoint Call Details'
        ],
        usesEndpointModels: true,
        usesUtilization: true,
        utilizationTabs: ['0' /*Historical Managed Endpoints*/] // Utilization only for Managed Endpoints
    },
    Infrastructure: {
        id: 'historical2infrastructure',
        uri: 'infrastructure',
        pageName: 'Infrastructure',
        shareNameDictionary: ['Infrastructure', 'Trunks']
    },
    Meetings: {
        id: 'historical2meetings',
        uri: 'meetings',
        pageName: 'Meetings',
        shareNameDictionary: ['Historical Meetings', 'Historical Meeting VMR', 'Historical Meeting Participants']
    },
    Rooms: {
        id: 'rooms',
        uri: 'rooms',
        pageName: 'Workspaces',
        shareNameDictionary: ['Workspaces'],
        usesUtilization: true,
        utilizationTabs: ['0']
    },
    User: {
        id: 'historical2user',
        uri: 'user',
        pageName: 'Users',
        shareNameDictionary: ['User']
    },
    Networks: {
        id: 'historical2networks',
        uri: 'networks',
        pageName: 'Networks',
        shareNameDictionary: ['Networks']
    }
};

function getDatasetRouteParams(dataset) {
    return {
        page: AA_PAGE,
        view: VIEW.DATASET + '-' + dataset.uri,
        pageName: dataset.pageName,
        permission: 'viewDatasets',
        datasetViewId: dataset.id,
        shareNameDictionary: dataset.shareNameDictionary,
        usesEndpointModels: dataset.usesEndpointModels,
        usesUtilization: dataset.usesUtilization,
        utilizationTabs: dataset.utilizationTabs
    };
}

function getDatasetRoutes(dataset) {
    if (_.isEmpty(_.get(dataset, 'uri'))) {
        throw new Error('Missing dataset.uri!');
    }

    return [
        { url: 'historical2/' + dataset.uri + '/link/{link}', params: _.assign({ level: 'filter' }, getDatasetRouteParams(dataset)) },
        { url: 'historical2/' + dataset.uri + '/tabid/{tabId}/link/{link}', params: _.assign({ level: 'filter' }, getDatasetRouteParams(dataset)) },
        { url: 'historical2/' + dataset.uri + '/tabid/{tabId}', params: _.assign({ level: 'tab' }, getDatasetRouteParams(dataset)) },
        // Use regular expressions so that we can take '/' as part of the params
        { url: new RegExp('historical2\/' + dataset.uri + '\/params\/' + RouteHelper.FILTER_PARAMS_REGEX), params: _.assign({ level: 'filter', regexGroups: ['params']}, getDatasetRouteParams(dataset)) },
        { url: new RegExp('historical2\/' + dataset.uri + '\/tabid\/([\\d\\w]+)\/params\/' + RouteHelper.FILTER_PARAMS_REGEX), params: _.assign({ level: 'filter', regexGroups: ['tabId', 'params']}, getDatasetRouteParams(dataset)) },
        { url: 'historical2/' + dataset.uri, params: _.assign({ level: 'view' }, getDatasetRouteParams(dataset)) },
    ];
}

function getNewDatasetRoute(datasetName, datasetTitle, datasetKey, hasDashboard) {
    return {
        url: 'historical2/dataset/' + datasetName,
        params: {
            appId: AA_APP,
            captureType: 'page',
            level: 'view',
            page: 'historical2-app-view',
            datasetName: datasetKey,
            hasDateRangePicker: false,
            hasExtendedDateRangePicker: true,
            hasDashboard: hasDashboard,
            pageId: 'historical2-dataset-' + datasetKey,
            permission: 'viewDatasets',
            title: datasetTitle,
            view: 'historical2-dataset',
        }
    };
}

function getNewLabsRoute(datasetName, datasetTitle, datasetKey, hasDashboard) {
    return {
        url: 'historical2/labs/' + datasetName,
        params: {
            appId: AA_APP,
            captureType: 'page',
            level: 'view',
            page: 'historical2-app-view',
            datasetName: datasetKey,
            hasDateRangePicker: false,
            hasExtendedDateRangePicker: true,
            hasDashboard: hasDashboard,
            pageId: 'historical2-dataset-' + datasetKey,
            permission: 'viewDatasets',
            title: datasetTitle,
            view: 'historical2-dataset',
        }
    };
}

export default _.concat([],
    // historical2 DASHBOARD
    { url: 'historical2/link/{link}', params: { appId: AA_APP, page: AA_PAGE, view: VIEW.DASHBOARD, level: 'filter' } },
    { url: 'historical2/dashboard/tabid/{tabId}/link/{link}', params: { appId: AA_APP, page: AA_PAGE, view: VIEW.DASHBOARD, level: 'filter' } },
    { url: 'historical2/dashboard/link/{link}', params: { appId: AA_APP, page: AA_PAGE, view: VIEW.DASHBOARD, level: 'filter' } },
    { url: 'historical2/dashboard/tabid/{tabId}', params: { appId: AA_APP, page: AA_PAGE, view: VIEW.DASHBOARD, level: 'tab' } },
    { url: 'historical2/dashboard', params: { appId: AA_APP, page: AA_PAGE, view: VIEW.DASHBOARD, level: 'view' } },
    // historical2 ADOPTION
    { url: 'historical2/adoption', params: { appId: AA_APP, page: AA_PAGE, view: VIEW.ADOPTION, level: 'view' } },
    { url: 'historical2/adoption/link/{link}', params: { appId: AA_APP, page: AA_PAGE, view: VIEW.ADOPTION, level: 'filter' } },
    { url: 'historical2/adoption/tabid/{tabId}/link/{link}', appId: AA_APP, params: { page: AA_PAGE, view: VIEW.ADOPTION, level: 'filter' } },
    { url: 'historical2/adoption/tabid/{tabId}', params: { appId: AA_APP, page: AA_PAGE, view: VIEW.ADOPTION, level: 'tab' } },
    // historical2 ISSUES
    { url: 'historical2/issues', params: { appId: AA_APP, page: AA_PAGE, view: VIEW.ISSUES, level: 'view' } },
    { url: 'historical2/issues/link/{link}', params: { appId: AA_APP, page: AA_PAGE, view: VIEW.ISSUES, level: 'filter' } },
    { url: 'historical2/issues/tabid/{tabId}/link/{link}', params: { appId: AA_APP, page: AA_PAGE, view: VIEW.ISSUES, level: 'filter' } },
    { url: 'historical2/issues/tabid/{tabId}', params: { appId: AA_APP, page: AA_PAGE, view: VIEW.ISSUES, level: 'tab' } },
    // historical2 CAPACITY
    { url: 'historical2/capacity', params: { appId: AA_APP, page: AA_PAGE, view: VIEW.CAPACITY, level: 'view' } },
    { url: 'historical2/capacity/link/{link}', params: { appId: AA_APP, page: AA_PAGE, view: VIEW.CAPACITY, level: 'filter' } },
    { url: 'historical2/capacity/tabid/{tabId}/link/{link}', params: { appId: AA_APP, page: AA_PAGE, view: VIEW.CAPACITY, level: 'filter' } },
    { url: 'historical2/capacity/tabid/{tabId}', params: { appId: AA_APP, page: AA_PAGE, view: VIEW.CAPACITY, level: 'tab' } },
    //historical2 ROOMS BOARDS
    { url: 'historical2/roomboard', params: { appId: AA_APP, page: AA_PAGE, view: VIEW.ROOMS_BOARDS, level: 'view' } },
    { url: 'historical2/roomboard/link/{link}', params: { appId: AA_APP, page: AA_PAGE, view: VIEW.ROOMS_BOARDS, level: 'filter' } },
    { url: 'historical2/roomboard/tabid/{tabId}/link/{link}', params: { appId: AA_APP, page: AA_PAGE, view: VIEW.ROOMS_BOARDS, level: 'filter' } },
    { url: 'historical2/roomboard/tabid/{tabId}', params: { appId: AA_APP, page: AA_PAGE, view: VIEW.ROOMS_BOARDS, level: 'tab' } },
    //historical2 ENDPOINT DETAILS
    { url: 'historical2/endpoint/{epid}/tabid/{tabId}', params: { appId: AA_APP, page: AA_PAGE, view: 'endpoint-detail-view', level: 'filter' } }, // legacy
    { url: 'historical2/endpoints/{epid}/tabid/{tabId}', params: { appId: AA_APP, page: AA_PAGE, view: 'endpoint-detail-view', level: 'filter' } },

    // -- DATASET VIEWS ---
    getNewDatasetRoute('managedEndpoints', 'Managed Endpoints', 'ManageEndpointXml'),
    getNewDatasetRoute('unManagedEndpoints', 'Unmanaged Endpoints', 'UnmanageEndpointXml'),
    // getNewDatasetRoute('inventory', 'Inventory', 'InventoryXml'),
    getNewDatasetRoute('infrastructure', 'Infrastructure', 'SystemXml'),
    getNewDatasetRoute('trunks', 'Trunks', 'TrunkXml'),
    getNewDatasetRoute('meetings', 'Meetings', 'MeetingXml'),
    // getNewDatasetRoute('vmrs', 'VMRs', 'VmrXml'),
    getNewDatasetRoute('calls', 'Calls', 'CallXml'),
    getNewDatasetRoute('participants', 'Participants', 'ParticipantXml'),
    getNewDatasetRoute('workspaces', 'Workspaces', 'scheduleRoomXML'),
    getNewDatasetRoute('users', 'Users', 'UserXml'),
    getNewDatasetRoute('networks', 'Networks', 'NetworkXml'),

    // -- SUMMARY VIEWS --
    getNewLabsRoute('networkInsights', 'Network Insights', 'summaryview.networkInsightsDetail', true),

    getDatasetRoutes(Dataset.Endpoints),
    getDatasetRoutes(Dataset.Infrastructure),
    getDatasetRoutes(Dataset.Meetings),
    getDatasetRoutes(Dataset.Rooms),
    getDatasetRoutes(Dataset.User),
    getDatasetRoutes(Dataset.Networks),
    // ------

    // historical2 REPORT SCHEDULES
    { url: 'historical2/reports', params: { page: AA_PAGE, permission: 'reportManager', view: VIEW.SCHEDULES, level: 'view', title: 'Reports' } },
    // historical2 CHART AND DETAILS - POPUP from Capacity dashboard
    { url: 'historical2/capacitydetails/link/{link}', params: { page: VIEW.CAPACITY_DETAILS, level: 'filter', type: 'system' } },
    { url: new RegExp('historical2\/capacitydetails\/params\/' + RouteHelper.FILTER_PARAMS_REGEX), params: { page: VIEW.CAPACITY_DETAILS, level: 'filter', regexGroups: ['params'], type: 'system' } },
    // historical2 CHART AND DETAILS - POPUP from Capacity dashboard (Cluster)
    { url: new RegExp('historical2\/clustercapacitydetails\/params\/' + RouteHelper.FILTER_PARAMS_REGEX), params: { page: VIEW.CAPACITY_DETAILS, level: 'filter', regexGroups: ['params'], type: 'cluster' } },
    // historical2 CHART AND DETAILS - POPUP from Capacity dashboard (Trunk)
    { url: 'historical2/clustercapacitydetails/link/{link}', params: { page: VIEW.CAPACITY_DETAILS, level: 'filter', type: 'cluster' } },
    { url: new RegExp('historical2\/trunkcapacitydetails\/params\/' + RouteHelper.FILTER_PARAMS_REGEX), params: { page: VIEW.CAPACITY_DETAILS, level: 'filter', regexGroups: ['params'], type: 'trunk' } },
    { url: 'historical2/trunkcapacitydetails/link/{link}', params: { page: VIEW.CAPACITY_DETAILS, level: 'filter', type: 'trunk' } },
    // historical2 CHART AND DETAILS - POPUP from Capacity dashboard (Concurrent Calls)
    { url: 'historical2/concurrentcallscapacitydetails/link/{link}', params: { page: VIEW.CAPACITY_DETAILS, level: 'filter', type: 'concurrentCalls' } },
    { url: new RegExp('historical2\/concurrentcallscapacitydetails\/params\/' + RouteHelper.FILTER_PARAMS_REGEX), params: { page: VIEW.CAPACITY_DETAILS, level: 'filter', regexGroups: ['params'], type: 'concurrentCalls' } },
    // historical2 CHART AND DETAILS - POPUP from Capacity dashboard (Concurrent Bandwidth)
    { url: 'historical2/concurrentbandwidthcapacitydetails/link/{link}', params: { page: VIEW.CAPACITY_DETAILS, level: 'filter', type: 'concurrentBandwidth' } },
    { url: new RegExp('historical2\/concurrentbandwidthcapacitydetails\/params\/' + RouteHelper.FILTER_PARAMS_REGEX), params: { page: VIEW.CAPACITY_DETAILS, level: 'filter', regexGroups: ['params'], type: 'concurrentBandwidth' } },
    // historical2 CHART AND DETAILS - POPUP from Capacity dashboard (Concurrent Meeting Peak)
    { url: 'historical2/sysconcurrentmeetingpeakbysystypecapacitydetails/link/{link}', params: { page: VIEW.CAPACITY_DETAILS, level: 'filter', type: 'sysConcurrentMeetingPeakBySysType' } },
    { url: new RegExp('historical2\/sysconcurrentmeetingpeakbysystypecapacitydetails\/params\/' + RouteHelper.FILTER_PARAMS_REGEX), params: { page: VIEW.CAPACITY_DETAILS, level: 'filter', regexGroups: ['params'], type: 'sysConcurrentMeetingPeakBySysType' } },
    { url: 'historical2/sysconcurrentmeetingpeakbysysnamecapacitydetails/link/{link}', params: { page: VIEW.CAPACITY_DETAILS, level: 'filter', type: 'sysConcurrentMeetingPeakBySysName' } },
    { url: new RegExp('historical2\/sysconcurrentmeetingpeakbysysnamecapacitydetails\/params\/' + RouteHelper.FILTER_PARAMS_REGEX), params: { page: VIEW.CAPACITY_DETAILS, level: 'filter', regexGroups: ['params'], type: 'sysConcurrentMeetingPeakBySysName' } },
    { url: 'historical2/systypeconcurrentmeetingpeakcapacitydetails/link/{link}', params: { page: VIEW.CAPACITY_DETAILS, level: 'filter', type: 'sysTypeConcurrentMeetingPeak' } },
    { url: new RegExp('historical2\/systypeconcurrentmeetingpeakcapacitydetails\/params\/' + RouteHelper.FILTER_PARAMS_REGEX), params: { page: VIEW.CAPACITY_DETAILS, level: 'filter', regexGroups: ['params'], type: 'sysTypeConcurrentMeetingPeak' } },
    // settings
    { url: 'historical2/settings', params: { page: AA_PAGE, permission: 'settings-view', view: VIEW.SETTINGS, level: 'view', title: 'Settings' } },
    { url: 'historical2/settings/tabid/{tabId}', params: { page: AA_PAGE, permission: 'settings-view', view: VIEW.SETTINGS, level: 'tab', title: 'Settings' } },
    // user details
    { url: 'historical2/userdetails/{userId}', params: { page: USER_DETAILS_CONTAINER, view: VIEW.USER_DETAILS, level: 'view', title: 'User Details' } },
    { url: 'historical2/userdetails/{userId}/{startDate}/{endDate}', params: { page: USER_DETAILS_CONTAINER, view: VIEW.USER_DETAILS, level: 'view', title: 'User Details' } },
    // all others redirect to dashboard
    { url: /historical2\/?.*/, params: { redirect: 'historical2/dashboard', page: AA_PAGE, view: VIEW.DASHBOARD, level: 'view' } }
);
